import React, { useContext, useState, useEffect } from "react";
import { BrowserRouter, Link, Route, Routes, Switch } from "react-router-dom";
import { GlobalState } from "./Globalstate";
import AppContainer from "./AppContainer";
import Dashboard from "./Pages/Dashboard";
import Invest from "./Pages/Invest";
import Deposit from "./Pages/Deposit";
import DepositHistory from "./Pages/DepositHistory";
import Withdrawal from "./Pages/Withdrawal";
import WithdrawalHistory from "./Pages/WithdrawalHistory";
import Settings from "./Pages/Settings";
import ProfitTracker from "./Pages/ProfitTracker";
import RefferalHistory from "./Pages/RefferalHistory"; 
import UserHistory from "./Pages/UserHistory"; 
import Support from "./Pages/Support";
import InvestmentFlow from "./Pages/InvestmentFlow";
import Kyc from "./Pages/Kyc";

// "agreement"  "ihistory"  "compoundingagreement" "icompound" "connect" "deposit" "dhistory" "withdraw" "whistory" "profile" compound

function App() {
  return (
    <GlobalState>
      {/* <ToastContainer className="foo" /> */}
      <BrowserRouter>
        <Routes>
          <Route exact path="/" element={<AppContainer />} />
          <Route path="/dashboards" element={<Dashboard />} />
          <Route path="/buy-plan" element={<Invest />} />
          <Route path="/tradinghistory" element={<ProfitTracker />} />
          {/* <Route path="/deposit" element={<Deposit />} /> */}
              <Route path="/deposit" element={<InvestmentFlow />} />
          <Route path="/dhistory" element={<DepositHistory />} />
          <Route path="/withdrawal" element={<Withdrawal />} />
          <Route path="/whistory" element={<WithdrawalHistory />} />
          <Route path="/account-settings" element={<Settings />} />
          <Route path="/referuser" element={<RefferalHistory />} />
          <Route path="/accounthistory" element={<UserHistory />} />
          <Route path="/support" element={<Support />} />
              <Route path="/kyc" element={<Kyc/>} />
          {/* Add more routes as needed */}
        </Routes>
      </BrowserRouter>
    </GlobalState>
  );
}

export default App;
